<template>
  <div class="row mb-5">
    <div class="row">
      <div class="info-horizontal pt-0 mt-3 mb-3">
        <div>
          <div
            v-if="!hasResults && !containsOnlyFreeTextQuestions"
            class="d-flex align-items-center"
          >
            <i class="bi bi-info-circle-fill fs-5 text-info me-4"></i>
            <p class="info-title fs-4">
              {{
                $t(
                  `widgetSurveyInfo.notEnoughResponses.${surveyDetails.details.status}`
                )
              }}
            </p>
          </div>
          <div v-else>
            <div class="d-flex align-items-center">
              <div
                v-if="surveyDetails.details.status == 'published'"
                class="icon icon-primary"
              >
                <i class="bi bi-arrow-repeat fs-5 text-info me-4"></i>
              </div>
              <div
                v-if="surveyDetails.details.status == 'published'"
                class="description"
              >
                <p class="info-title fs-4">
                  {{ $t('widgetSurveyInfo.status.published') }}
                </p>
              </div>
              <div
                v-if="surveyDetails.details.status == 'completed'"
                class="icon icon-primary"
              >
                <i class="bi bi-check-lg fs-5 text-success me-4"></i>
              </div>
              <div
                v-if="surveyDetails.details.status == 'completed'"
                class="description"
              >
                <p class="info-title fs-4">
                  {{ $t('widgetSurveyInfo.status.completed') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyInfoStatus',
  props: {
    surveyDetails: Object,
    hasResults: Boolean,
    containsOnlyFreeTextQuestions: {
      type: Boolean,
      default: false
    }
  },
  computed: {}
}
</script>

<style>
.info-title {
  margin-bottom: 0px;
}
</style>
